import { binDBKeys } from "src/pages/binOverview/BinCommander";
import { queryOptions } from "./v4QueryOptions/queryOptions";
import BinApiService from "src/api/BinApiService";

export const allBinsQueryOptions = queryOptions({
    queryKey: binDBKeys.allBin(),
    queryFn: (q) => BinApiService.getAllBins(q.signal)
});